import styled, { createGlobalStyle } from 'styled-components'
import { VPIconsFontFamily } from 'components/VPIcon/style'
import vpIconEOT from 'static/fonts/vp/eot/VPTIcons.eot'
import vpIconSVG from 'static/fonts/vp/svg/VPTIcons.svg'
import vpIconTTF from 'static/fonts/vp/ttf/VPTIcons.ttf'
import vpIconWOFF from 'static/fonts/vp/woff/VPTIcons.woff'

const GABARIT_CONTAINER_MAX_WIDTH = 1228
const GABARIT_CONTAINER_MIN_WIDTH = 995
const GABARIT_CONTENT_MIN_HEIGHT = 500

const Container = styled.div`
  color: ${({ theme }) => theme.colors.text.body};
  font-family: ${({ theme }) => theme.typography.body.text.fontFamily};
  font-size: ${({ theme }) => theme.typography.body.text.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.text.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.text.lineHeight};
  margin: 0 auto;
  max-width: ${GABARIT_CONTAINER_MAX_WIDTH}px;
  min-width: ${GABARIT_CONTAINER_MIN_WIDTH}px;
  padding: 0;

  /* mobile - tablet */
  @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
    border: 0;
    min-width: inherit;
  }

  /* desktop */
  @media only screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) and (max-width: calc(${({ theme }) => theme.breakpoint.desktopHD} - 1px)) {
    padding: 0 ${({ theme }) => theme.space.s300};
  }
`

const Content = styled.div`
  height: 100%;
  min-height: ${GABARIT_CONTENT_MIN_HEIGHT}px;
`

const GlobalStyle = createGlobalStyle`
  body,
  html,
  #wrapper,
  #wrapper #container,
  #wrapper #container #content > div {
    min-height: 100%;
  }

  #portal-tooltip {
    height: 0;
    position: relative;
    z-index: 99;
  }

  #wrapper.modalOpened {
    filter: blur(5px);
  }

  #wrapper #container #content {
    background-color: ${({ theme }) => theme.colors.white.s100};
  }

  @font-face {
    font-display: block;
    font-family: ${VPIconsFontFamily};
    font-style: normal;
    font-weight: normal;
    src: url('${vpIconEOT}');
    src: url('${vpIconEOT}#iefix') format('embedded-opentype'),
         url('${vpIconTTF}') format('truetype'),
         url('${vpIconWOFF}') format('woff'),
         url('${vpIconSVG}') format('svg');
  }

  @media only screen and (max-width : 1023px) {
    body {
      padding: 0;
    }

    #content {
      background-position: center calc(50% - 143px);
      height: 100%;
      min-height: auto;
    }

    #wrapper {
      border-width: 0;
      max-width: inherit;
      min-width: inherit;
      padding: 0;
      width: 100%;
    }
  }
`

export { Container, Content, GlobalStyle }
